export default __webpack_public_path__ + "static/media/404.25405efd.png";